import strings from 'strings';

export const MAX_NUMBER_OF_FILES = 4;
export const MAX_FILE_NAME_LENGTH = 45;

export const EMPTY_CATEGORY_MESSAGE = strings.sendoutsV2.drawers.tabs.attachments.noAttachments;

export const AttachmentsVariant = {
  Create: 'create',
  Readonly: 'readonly',
  UploadOnly: 'uploadOnly'
};

export const ATTACHMENTS_VARIANT_PROPS = {
  [AttachmentsVariant.Create]: {
    showSelector: true,
    showUploader: true
  },
  [AttachmentsVariant.UploadOnly]: {
    showSelector: false,
    showUploader: true
  }
};
